export const CORNER_GRADIENT =
  'radial-gradient(50% 140% at 0% 0%, #9DB8F5 0%, #C3D3F9 25%, #EDF1FE 55%, #F6F8FF 80%)';
export const CORNER_GRADIENT_HOVER =
  'radial-gradient(100% 250% at 0% 0%, #9DB8F5 0%, #C3D3F9 25%, #EDF1FE 55%, #F6F8FF 80%)';

export const GRID_ITEM_FLAT_BACKGROUND = '#F6F8FF';
export const GRID_ITEM_ICON_BACKGROUND = '#1555FC0A';
export const GRID_ITEM_LABEL_COLOR = '#707D9F';
export const GRID_ITEM_VALUE_COLOR = '#0B1370';
